import * as React from 'react'

export type EditableTransactionColumns = {
  areaCode?: boolean
  deliveryPeriodType?: boolean
  deliveryDateRange?: boolean
  deliveryHourType?: boolean
  unitPricePerKwh?: boolean
  volumeInKw?: boolean
  floatingIndexCode?: boolean
}

type EditableColumnsContextType = {
  editableColumns: EditableTransactionColumns
}

const EditableColumnsContext = React.createContext<
  EditableColumnsContextType | undefined
>(undefined)

export const useEditableTransaction = (): EditableTransactionColumns => {
  const context = React.useContext(EditableColumnsContext)
  return context?.editableColumns ?? {}
}

type Props = {
  editableColumns: EditableTransactionColumns
  children: React.ReactNode
}

export const EditableTransactionProvider: React.FC<Props> = ({
  editableColumns,
  children,
}) => {
  return (
    <EditableColumnsContext.Provider value={{ editableColumns }}>
      {children}
    </EditableColumnsContext.Provider>
  )
}
